/**
 * LP01 Carousel (MC)
 * Custom Element genérico y reutilizable: sincroniza puntos indicadores
 * con la tarjeta visible en un carrusel horizontal (mobile), usando
 * scroll nativo (swipe sin JS) + IntersectionObserver solo para el
 * estado de los puntos. Los puntos también permiten saltar a una
 * tarjeta directamente al hacer clic.
 *
 * Usado por: LP01 Steps (MC), LP01 Transformations (MC).
 * Marcado esperado dentro de <lp01-carousel-mc>:
 *   - un contenedor con [data-carousel-track]
 *   - tarjetas hijas con [data-carousel-card]
 *   - botones de punto con [data-carousel-dot] y
 *     [data-carousel-dot-target="id-de-la-tarjeta"]
 *
 * Vanilla JS, sin dependencias externas.
 */

(function () {
  if (customElements.get('lp01-carousel-mc')) return;

  class Lp01CarouselMC extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-carousel-card]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-carousel-dot]'));

      if (!this.track || !this.cards.length || !this.dots.length) return;

      this._onDotClick = this.onDotClick.bind(this);
      this.dots.forEach(function (dot) {
        dot.addEventListener('click', this._onDotClick);
      }, this);

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
          root: this.track,
          threshold: 0.6
        });
        this.cards.forEach(function (card) {
          this.observer.observe(card);
        }, this);
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.dots.forEach(function (dot) {
        dot.removeEventListener('click', this._onDotClick);
      }, this);
    }

    onIntersect(entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var index = this.cards.indexOf(entry.target);
        this.setActiveDot(index);
      }, this);
    }

    setActiveDot(index) {
      this.dots.forEach(function (dot, dotIndex) {
        if (dotIndex === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    onDotClick(event) {
      var targetId = event.currentTarget.getAttribute('data-carousel-dot-target');
      var targetCard = targetId ? document.getElementById(targetId) : null;
      if (!targetCard) return;
      targetCard.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }

  customElements.define('lp01-carousel-mc', Lp01CarouselMC);
})();